module.exports = __webpack_public_path__ + "img/nike-banner02.81c532a3.jpg";